
import { apiService } from './service/api.service'
import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'

import jwtService from '../src/service/jwt.service'
import { createUrl } from './utils/helpers'
import environment from '../environment'
import NotificationSideMenu from './components/notify-clients/NotificationSideMenu.vue'
interface MenuItem {
  icon: string
  label: string
  url?: string
  disable?: boolean
  children?: MenuItem[]
}

export default Vue.extend({
  name: 'App',
  components: {
    NotificationSideMenu
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'userInfo']),
    isLoginPage () {
      return this.$route.name === 'adminLogin'
    },
    userInitial (): string {
      const name = this.userInfo?.name || this.userInfo?.email || ''
      return name ? name.substring(0, 1).toUpperCase() : '?'
    },
    // Header breadcrumb'ı menü ağacından türetilir; router'da ayrı bir
    // başlık tablosu tutmaya gerek kalmıyor (frontend header'ıyla aynı desen).
    crumb (): { section: string; page: string } {
      const routeName = this.$route.name
      for (const item of this.menu as MenuItem[]) {
        if (item.children) {
          const child = item.children.find(c => this.matches(c.url))
          if (child) return { section: item.label, page: child.label }
        } else if (this.matches(item.url)) {
          return { section: '', page: item.label }
        }
      }
      // Menüde karşılığı olmayan alt sayfalar (ör. version detay ekranları)
      return { section: '', page: this.routeFallbackLabel(routeName) }
    }
  },
  data: () => ({
    drawer: true,
    isMobile: false,
    // v-list-group open state per group label; VList itself keeps only one open
    openGroups: {} as Record<string, boolean>,
    menu: [
      {
        icon: 'mdi-monitor-dashboard',
        label: 'Dashboard',
        url: 'dashboard',
        disable: false
      },
      {
        icon: 'mdi-account-group-outline',
        label: 'Users & Licences',
        children: [
          {
            icon: 'mdi-account-group-outline',
            label: 'Users',
            url: 'users',
            disable: false
          },
          {
            icon: 'mdi-card-account-details-outline',
            label: 'Licences',
            url: 'licences',
            disable: false
          },
          {
            icon: 'mdi-gift-outline',
            label: 'Customer License Gifts',
            url: 'gift-backfill',
            disable: false
          },
          {
            icon: 'mdi-sitemap-outline',
            label: 'User Journey',
            url: 'user-journey',
            disable: false
          },
          {
            icon: 'mdi-chart-timeline-variant',
            label: 'Lifecycle Reports',
            url: 'lifecycle-reports',
            disable: false
          },
          {
            icon: 'mdi-email-multiple-outline',
            label: 'Email Automations',
            url: 'email-campaigns',
            disable: false
          }
        ]
      },
      {
        icon: 'mdi-handshake-outline',
        label: 'Partners',
        children: [
          {
            icon: 'mdi-handshake-outline',
            label: 'Resellers',
            url: 'resellers',
            disable: false
          },
          {
            icon: 'mdi-file-document-check-outline',
            label: 'Partner Applications',
            url: 'partner-applications',
            disable: false
          }
        ]
      },
      {
        icon: 'mdi-cellphone-link',
        label: 'Devices',
        children: [
          {
            icon: 'mdi-cellphone-link',
            label: 'Devices',
            url: 'devices',
            disable: false
          },
          {
            icon: 'mdi-lan-connect',
            label: 'Connected Clients',
            url: 'clients',
            disable: false
          },
          {
            icon: 'mdi-server',
            label: 'Cordatus Services',
            url: 'services',
            disable: false
          }
        ]
      },
      {
        icon: 'mdi-cube-outline',
        label: 'Containers',
        children: [
          {
            icon: 'mdi-cube-outline',
            label: 'Containers',
            url: 'dockers',
            disable: false
          },
          {
            icon: 'mdi-tag-multiple-outline',
            label: 'Container Tags',
            url: 'containerTags',
            disable: false
          },
          {
            icon: 'mdi-cog-outline',
            label: 'Container Options',
            url: 'containerOptions',
            disable: false
          }
        ]
      },
      {
        icon: 'mdi-chip',
        label: 'Engines & Models',
        children: [
          {
            icon: 'mdi-code-braces',
            label: 'Engines',
            url: 'engines',
            disable: false
          },
          {
            icon: 'mdi-cube-scan',
            label: 'LLM Engines',
            url: 'llm-engines',
            disable: false
          },
          {
            icon: 'mdi-server-network',
            label: 'Sparkrun Recipes',
            url: 'sparkrunRecipes',
            disable: false
          },
          {
            icon: 'mdi-memory',
            label: 'VRAM Calculator',
            url: 'vram-calculator',
            disable: false
          },
          {
            icon: 'mdi-chip',
            label: 'Jetson Compatibility',
            url: 'jetson-compatibility',
            disable: false
          }
        ]
      },
      {
        icon: 'mdi-tune',
        label: 'System',
        children: [
          {
            icon: 'mdi-file-cog-outline',
            label: 'Environment Profile',
            url: 'envProfile',
            disable: false
          },
          {
            icon: 'mdi-tag',
            label: 'Version Management',
            url: 'versionManagement',
            disable: false
          },
          {
            icon: 'mdi-text-box-outline',
            label: 'Logs',
            url: 'logs',
            disable: false
          }
        ]
      }
    ]
  }),
  beforeDestroy () {
    if (typeof window === 'undefined') return

    window.removeEventListener('resize', this.onResize)
  },
  beforeMount () {
    if (!this.isLoginPage) {
      this.authcheck()
    }
  },

  mounted () {
    this.onResize()
    this.syncOpenGroup()

    window.addEventListener('resize', this.onResize, { passive: true })
  },

  watch: {
    $route () {
      this.syncOpenGroup()
    }
  },

  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 600
    },

    // Bir menü kaydının url'i (route name) aktif rotayla eşleşiyor mu
    matches (url?: string): boolean {
      if (!url) return false
      return this.$route.matched.some(record => record.name === url)
    },

    // Menüde yeri olmayan rotalar icin route adından okunur bir başlık üret
    routeFallbackLabel (name?: string | null): string {
      if (!name) return 'Admin'
      return name
        .replace(/[-_]/g, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\b\w/g, c => c.toUpperCase())
    },

    go (url?: string) {
      if (!url) return
      this.$router.push({ name: url }).catch(() => undefined)
    },

    // in mini variant a group has no room to expand, so open the drawer first
    onMiniClick (item: MenuItem) {
      if (item.children) {
        this.openGroup(item.label)
        this.drawer = true
        return
      }
      this.go(item.url)
    },

    openGroup (label: string) {
      this.$set(this.openGroups, label, true)
    },

    isItemActive (item: MenuItem): boolean {
      const names = item.children
        ? item.children.map(child => child.url)
        : [item.url]

      return this.$route.matched.some(
        record => !!record.name && names.includes(record.name)
      )
    },

    // keep the group holding the current route expanded
    syncOpenGroup () {
      const group = this.menu.find(
        (item: MenuItem) => !!item.children && this.isItemActive(item)
      )
      if (group) this.openGroup(group.label)
    },

    async authcheck () {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const token = jwtService.getToken()
      if (!token) {
        this.$store.dispatch('setAuthenticated', false)
        return
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const res: any = await apiService.get('confirm-login/').catch(() => {
        this.$store.dispatch('setAuthenticated', false)
        return false
      })
      if (res) {
        this.$store.dispatch('setAuthenticated', true)
        this.$store.commit('setUser', res.data.user)
      }
    },
    toggleDarkTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    },

    goToDashboard () {
      window.location.href = createUrl(
        environment.frontendSecure,
        environment.frontendUrl,
        environment.frontendPort
      )
    },

    async logout () {
      this.$store.dispatch('setAuthenticated', false)
      this.$store.commit('setUser', [])
      jwtService.destroyToken()
      this.$router.push({ name: 'adminLogin' }).catch((err: Error) => {
        if (err.name !== 'NavigationDuplicated') throw err
      })
    }
  }
})
